import Axios from "axios";
import {
  SET_ATTENDANCE_REGISTER_REPORT,
  UNSET_ATTENDANCE_REGISTER_REPORT,
} from "@/store/mutation-types";
import {
  getAttendanceRegisterReport,
} from "@/store/api";

const state = {
  attendanceRegisterReport: [],
};

const getters = {
  getAttendanceRegisterReport(state) {
    return state.attendanceRegisterReport;
  },
};

const mutations = {
  [SET_ATTENDANCE_REGISTER_REPORT](state, data) {
    state.attendanceRegisterReport = data;
  },
  [UNSET_ATTENDANCE_REGISTER_REPORT](state) {
    state.attendanceRegisterReport = [];
  },
};

const actions = {
  getAttendanceRegisterReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getAttendanceRegisterReport}`, { params: data })
        .then((response) => {
          commit(SET_ATTENDANCE_REGISTER_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_ATTENDANCE_REGISTER_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

